<a
  [routerLink]="['/product-details', product?.slug]"
  class="game-card-beta"
  *ngIf="product"
>
  <div class="game-card-beta__image-container">
    <!-- Main game image -->
    <img
      class="game-card-beta__image"
      [src]="mainAsset?.preview"
      [alt]="product?.name"
    />
  </div>

  <div class="game-card-beta__content">
    <!-- Top section with title and price -->
    <div class="game-card-beta__header">
      <div class="game-card-beta__logo-overlay" *ngIf="mainAsset">
        <div class="game-card-beta__logo-image-container">
          <img [src]="mainAsset?.preview" [alt]="product?.name + ' logo'" />
        </div>
      </div>

      <!-- Price display with badges in horizontal line -->
      <div class="game-card-beta__price-container">
        <div class="game-card-beta__badges">
          <!-- New badge if applicable -->
          <div class="game-card-beta__new-badge">New</div>

          <!-- Discount badge if applicable -->
          <div class="game-card-beta__discount-badge" *ngIf="discountPercentage > 0">
            -{{ discountPercentage }}%
          </div>

          <div class="game-card-beta__price">
            <div class="game-card-beta__original-price" *ngIf="discountPercentage > 0">
              {{ product.variants[0].price | currency:'EUR':'symbol':'1.2-2' }}
            </div>
            <div class="game-card-beta__current-price">
              {{ getDiscountedPrice() | currency:'EUR':'symbol':'1.2-2' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <h2 class="game-card-beta__title">{{ product?.name }}</h2>
    <!-- Game tags -->
    <div class="game-card-beta__tags">
      <div
        class="game-card-beta__tag"
        *ngFor="let facet of product.facetValues"
        (click)="onTagClick($event, facet)"
      >
        {{ facet?.name }}
      </div>
    </div>

    <!-- Reviews section -->
    <div class="game-card-beta__reviews">
      <span class="game-card-beta__rating">{{ rating }}</span>
      <span class="game-card-beta__separator"></span>
      <span class="game-card-beta__review-count">{{ formatReviewCount(reviewCount) }} User Reviews</span>
    </div>

    <!-- Platforms and release date -->
    <div class="game-card-beta__footer">
      <div class="game-card-beta__platforms">
        <span
          class="game-card-beta__platform-icon"
          *ngFor="let platform of visiblePlatforms"
          nz-icon
          [nzType]="platform.icon"
        ></span>
      </div>
      <div class="game-card-beta__release-date">{{ formatDate(releaseDate) }}</div>
    </div>
  </div>
</a>

<!-- Skeleton loader -->
<div class="game-card-beta-skeleton" *ngIf="!product"></div>
